// TODO: this should go in src not in replacmeents
import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/navisionimport',
    name: 'NavisionImportView',
    component: () => import(
      /* webpackChunkName: "navision-import-view" */ '../../src/modules/navision/components/NavisionImportView'
    ),
    meta: {
      moduleId: 'navisionImport',
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/navisionexport',
    name: 'NavisionExportView',
    component: () => import(
      /* webpackChunkName: "navision-export-view" */ '../../src/modules/navision/components/NavisionExportView'
    ),
    meta: {
      moduleId: 'navisionExport',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated,
  }
]